import NewApiKeyConfirmationModalContent from "v2/api-key-management/components/modals/NewApiKeyConfirmationModalContent";


export const path = "confirm-new";

export const Component = NewApiKeyConfirmationModalContent;
